import { Controller } from "@hotwired/stimulus"

// Tabs for the Ansicht dropdown's card configuration: "Mitarbeiter" vs "Fuhrpark". Each tab shows
// its own card size + field picker panel; everything else in the dropdown stays shared below.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { currentTab: { type: String, default: "employee" } }

  connect() {
    this.showTab(this.currentTabValue)
  }

  // The tab buttons live inside the dropdown menu; stop the click from bubbling to the dropdown
  // toggle (which would close the menu).
  switch(event) {
    event.preventDefault()
    event.stopPropagation()
    this.showTab(event.currentTarget.dataset.tab)
  }

  showTab(tabName) {
    this.currentTabValue = tabName

    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tab === tabName
      tab.classList.toggle("border-bautask-green", active)
      tab.classList.toggle("text-bautask-green", active)
      tab.classList.toggle("border-transparent", !active)
      tab.classList.toggle("text-gray-500", !active)
    })

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.panel !== tabName)
    })
  }
}
